import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungBochum() {
  return (
    <CityPageTemplate
      city="Bochum"
      slug="bochum"
      intro="Bochum entwickelt sich weiter – sei auch finanziell einen Schritt voraus."
      description="Unabhängige Finanzberatung für Bochum – 100% digital, kostenlose Erstberatung. Altersvorsorge, ETF, Steueroptimierung & staatliche Förderungen."
    />
  );
}
